import i18n from 'l10n';
import Handlebars from 'handlebars';
import GenericView from 'js/views/generic.view';
import ContentGalleryCollection from 'js/models/content.paginated.collection';
import ContentTileView from 'js/views/content.tile.view';
import PaginatedView from 'js/views/pagination.view';
import Template from 'js/templates/content.gallery.hbs';
import {delegateEvent} from "../utils/event.delegator";
import {debounce, domain, el, on, tagName, template} from "../adapters/backbone-decorators";

require('interfaceAdapter');

@el(".content-gallery-container")
@tagName("span")
@domain(".page")
@template(Template)
class ContentTilesView extends GenericView {

    constructor(options) {
        super(options);
        this.inSearch = false;
        this.totalLength = 0;
        this.inPromoConfiguration = false;
        this.inVoucherConfiguration = false;
        this.CCview = options.CCview;
        this.selectedFile = options.selectedFile;
        this.inPromoConfiguration = options.inPromoConfiguration;
        this.inVoucherConfiguration = options.inVoucherConfiguration;
        this.inServiceConfiguration = options.inServiceConfiguration;
        this.surveyComponent = options.surveyComponent;
        this.surveyComponentId = options.surveyComponentId;
        this.contentCollection = new ContentGalleryCollection();
        this.collectionUrl = this.contentCollection.url;
        if (this.inVoucherConfiguration || this.inServiceConfiguration) {
            this.contentCollection.url = this.collectionUrl + "?" + "filetype=image";
        } else {
            this.contentCollection.url = this.collectionUrl;
        }

        var tempTemplate = Handlebars.compile(Template)();
        this.$el.html(tempTemplate);
        this.on("uploaded:content", () => {
            console.log("Detected new uploaded content. Fetching...");
            this.contentCollection.fetch();
        });
        this.contentCollection.bind("sync", this.renderCollection, this);
        this.loadContentGallery();
    }

    delegateEvents(events) {
        this.cid = 'add-dialog';
        super.delegateEvents(events);
    }

    render() {
        super.render();
    }

    renderCollection() {
        this.$("#fileTiles").empty();

        this.contentCollection.each(model => {
            this.renderModel(model);
        });

        this.$('[data-i18n]').i18n();
        if (this.pagination) {
            console.log("this.pagination is zero?: " + this.pagination);
            this.pagination.remove();
        }
        // Render collection the 1st time
        this.pagination = new PaginatedView({collection: this.contentCollection});
        this.pagination.render();
        if (!this.inSearch) {
            this.totalLength = this.contentCollection.count;
        }

        this.$("#filessearchbox").toggle(!this.totalLength._isNaN);
        this.$("#nofilessearch").toggle(!this.totalLength);

        if (!this.inVoucherConfiguration && !this.inServiceConfiguration && !this.inPromoConfiguration)
            this.$('#filessearchbox').addClass('changepadding10to5');
        // Replace view's pagination
        this.$('#pagination').html(this.pagination.$el);
        $("#numberOfUploadedFiles").html(i18n.t("content.numberOfUploadedFiles", {count: this.contentCollection.count}));

    }

    renderModel(model, scroll) {
        const view = new ContentTileView({
            model,
            parentContentCollectionView: this,
            inPromoConfiguration: this.inPromoConfiguration,
            inVoucherConfiguration: this.inVoucherConfiguration,
            inServiceConfiguration: this.inServiceConfiguration
        });
        delegateEvent(view, this, "selected:content");
        view.render();
        var el = view.el;
        if (model.get("contentId") === this.selectedFile) $(el).find(".tile").addClass("selected");
        this.$el.find('#fileTiles').append(el);
        if (scroll) {
            el.scrollIntoView();
        }
    }

    loadContentGallery() {
        this.contentCollection.getFirstPage();
    }

    deleteContent(contentId) {
        $.ajaxDefaultQ({
            url: `/CampaignCloud/Content/DeleteContent/${contentId}`,
            type: 'GET',
            dataType: "json"
        }).done(() => {
            this.contentCollection.url = this.collectionUrl;
            this.$('.searchbox').val("");
            this.contentCollection.getFirstPage();
        }).fail(function (response) {
            console.info(response);
        });
    }

    @debounce(800)
    @on('keyup .content-searchbox')
    searchByFilter() {
        var filename = null;

        this.$('.content-searchbox').each(function (index, elem) {
            if ($(elem).hasClass('filter_message') && $(elem).val()) {
                filename = $(elem).val().toLowerCase();
            }
        });
        var startQuery = this.inVoucherConfiguration || this.inServiceConfiguration ? "?filetype=image&" : "?";
        if (filename) {
            this.contentCollection.url = `${this.collectionUrl + startQuery}filename=${filename}`;
            this.inSearch = true;
        } else {
            this.contentCollection.url = this.collectionUrl + startQuery;
            this.inSearch = false;
        }

        this.contentCollection.getFirstPage();
    }
}

export default ContentTilesView;
